import React, { useState, useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import { NavLink } from 'react-router-dom';
import AppsList from '../../components/global/footer/apps';
import moment from 'moment';
import {fetching, getOrderStatus} from '../../../api';
import screeningLogoSmall from '../../../assets/img/skrinig40_52x48.svg';

const Confirmation = ({ handleSubmit, job, onSubmit, patients, time, onClose, watch, showSearchBtn, user, timeSlot, doctor, paymentSuccessful, setPaymentSuccessful, appointment, searchFilters }) => {
  const patient = patients.data.find((patient) => patient.id === Number(watch('patient')));
  const [remainingMinutes, setRemainingMinutes] = useState(30);
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const [iframeHeight, setIframeHeight] = useState(800);
  const [isExpired, setIsExpired] = useState(false);
  const iframeRef = useRef(null);
  
  // Get city from timeSlot if available
  if(!job) job = doctor.jobs.find(({ id }) => id === timeSlot.job_id);

  // Effect for payment status polling
  useEffect(() => {
    if (appointment.data?.order?.number) {
      let statusCheckTimer;
      
      const checkOrderStatus = async () => {
        try {
          const result = await getOrderStatus(appointment.data.order.number);
          
          if (result.success && result.payment_status === 'paid') {
            setPaymentSuccessful(true);
            clearInterval(statusCheckTimer);
          }
        } catch (error) {
          console.error('Error checking order status:', error);
        }
      };
      
      // Initial check
      checkOrderStatus();
      
      // Set up interval for checking every 5 seconds
      statusCheckTimer = setInterval(checkOrderStatus, 5000);
      
      return () => clearInterval(statusCheckTimer);
    }
  }, [appointment.data?.order?.number]);

  useEffect(() => {
    if (appointment.data?.order) {
      const createdAt = new Date(appointment.data.order.created_at);
      const expiryTime = new Date(createdAt.getTime() + 30 * 60 * 1000); // 30 minutes from creation
      
      let timer; // Declare timer variable in the outer scope
      
      const updateCountdown = () => {
        const now = new Date();
        const diff = Math.max(0, Math.floor((expiryTime - now) / 1000)); // difference in seconds
        
        if (diff <= 0) {
          setRemainingMinutes(0);
          setRemainingSeconds(0);
          setIsExpired(true); // Set expiration flag
          clearInterval(timer);
        } else {
          setRemainingMinutes(Math.floor(diff / 60));
          setRemainingSeconds(diff % 60);
        }
      };
      
      // Initial update
      updateCountdown();
      
      // Update every second
      timer = setInterval(updateCountdown, 1000);
      
      return () => clearInterval(timer);
    }
  }, [appointment.data]);

  // Add listener for iframe height messages
  useEffect(() => {
    const handleMessage = (event) => {
      
      // Verify origin for security (adjust based on your payment provider's domain)
      if (appointment.data?.order?.payment_link && event.origin === new URL(appointment.data.order.payment_link).origin) {
        try {
          const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
          if (data && data.height) {
            setIframeHeight(data.height);
          }
          // Кнопка "назад" або "повернутись назад"
          if (data.message === "close-button") {
              onClose();
          }
        
          // Діпклінк для мобільного додатку
          if (data.message === "monopay-link") {
              window.location.href = data.value;
          }
        } catch (e) {
          console.error("Error parsing iframe message", e);
        }
      }
    };

    window.addEventListener('message', handleMessage);
    
    // Cleanup
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [appointment.data]);
  
  // Fallback method using resize observer
  useEffect(() => {
    if (!iframeRef.current) return;
    
    // Try to access iframe content if from same origin
    const resizeIframe = () => {
      try {
        if (iframeRef.current.contentWindow && iframeRef.current.contentWindow.document.body) {
          const newHeight = iframeRef.current.contentWindow.document.body.scrollHeight;
          if (newHeight > 100) { // Sanity check
            setIframeHeight(newHeight);
          }
        }
      } catch (e) {
        // Silent fail on cross-origin issues
      }
    };

    // Try initial resize after load
    iframeRef.current.addEventListener('load', resizeIframe);
    
    // Poll occasionally for size changes
    const interval = setInterval(resizeIframe, 1000);
    
    return () => {
      if (iframeRef.current) {
        iframeRef.current.removeEventListener('load', resizeIframe);
      }
      clearInterval(interval);
    };
  }, [iframeRef.current, appointment.data]);

  if(appointment.data?.order) {
    const paymentTimerStyle = {
      padding: '5px 10px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      border: '1px solid #e9ecef',
      marginBottom: '0px',
      fontSize: '16px',
      textAlign: 'center',
      fontWeight: '500',
      color: '#343a40'
    };
    
    const countdownTimerStyle = {
      fontWeight: 'bold',
      color: '#dc3545',
      fontSize: '18px',
      padding: '3px 8px',
      backgroundColor: '#fff3f3',
      borderRadius: '4px',
      display: 'inline-block',
      margin: '0 5px'
    };
    
    const expiredMessageStyle = {
      padding: '15px 20px',
      backgroundColor: '#f8d7da',
      borderRadius: '8px',
      border: '1px solid #f5c6cb',
      marginBottom: '20px',
      fontSize: '16px',
      textAlign: 'center',
      fontWeight: '500',
      color: '#721c24'
    };
    
    // Show expired message or iframe payment form
    if (isExpired) {
      return (
        <>
          <div style={expiredMessageStyle}>
            Нажаль час резервування сплив, ваш запис на прийом скасовано.
          </div>
          <div className="text-center mt-4">
            <Button variant="primary" className="submit-button" onClick={onClose}>
              Закрити
            </Button>
          </div>
        </>
      );
    }
    
    if (paymentSuccessful) {
      return (
        <>
          <div className='text-success mb-3'>
            <p className='text-center'><strong>Шановний Пацієнт!</strong></p>
            <p className='text-center mb-3'>Процедура запису Вашого візиту до лікаря успішно завершена.</p>
            <p className='attention'><strong>Увага!</strong><br />
            <strong>*</strong> Звертаємо Вашу увагу, що дані щодо Вашого запису на прийом знаходяться в Вашому персональному кабінеті на нашому сайті та у мобільному додатку</p>
            <p className='attention'>
            <strong>*</strong> Просимо Вас прийти за 15 хвилин до часу візиту та повідомити реєстратуру</p>
            <p className='attention'>
            <strong>*</strong> Квитанцію про оплату ви можете завантажити в вашому застосунку Монобанк</p>
          </div>
          <div className="text-center mt-4">
            <Button variant="primary" className="submit-button" onClick={onClose}>
              Закрити
            </Button>
          </div>
          <style>{`
            .text-success {
              font-size: 17px;
              font-weight: 500;
              color: #25953e !important;
            }
            .attention {
              font-size: 14px;
              font-weight: 400;
              color: #005c9f;
            } 
          `}</style>
        </>
      );
    }
    
    return (
      <>
        <div style={paymentTimerStyle}>
          Ми тримаємо для вас резерв ще <span style={countdownTimerStyle}>
            {remainingMinutes}:{remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds}
          </span> хвилин. 
          <p>Встигніть оплатити, щоб підтвердити запис.</p>
        </div>
        <div className="iframe-container">
          <iframe
              ref={iframeRef}
              id="payFrame"
              title="monopay"
              width="100%"
              height={iframeHeight}
              src={appointment.data.order.payment_link}
              allow="payment *"
              style={{
                borderRadius: "24px", 
                border: "none", 
                overflow: "hidden",
                transition: "height 0.3s ease"
              }}
              onLoad={(e) => {
                // Try to send a message to the iframe to request height updates
                try {
                  e.target.contentWindow.postMessage('REQUEST_HEIGHT', '*');
                } catch (err) {
                  console.log('Could not send height request to iframe');
                }
              }}
          ></iframe>
        </div>
      </>
    );
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="confirmation_of_entry success">
      { searchFilters?.screening_40_plus ? (
        <>
          <div className="screening-confirmation">
            <div className="screening-header">
              <div className="screening-logo-wrapper">
                <img src={screeningLogoSmall} alt="Скринінг 40+" className="screening-logo" />
              </div>
              <div className="screening-content">
                <p className="screening-title">Ваш запис на програму «Скринінг здоров'я 40+» підтверджено.</p>
                <p className="screening-text">
                  Ми чекаємо вас у нашому закладі <strong>{moment(timeSlot.datetime).format('DD.MM.YYYY о HH:mm')}</strong>, щоб ви могли пройти обстеження швидко та комфортно.
                </p>
              </div>
            </div>
            {job?.division && (
              <>
                <div className="screening-info institution">
                  <strong>Заклад:</strong>
                  <span>{job.division.full_name}</span>
                </div>
                {job.division.address?.display_text && (
                  <div className="screening-info institution">
                    <strong>Адреса закладу:</strong>
                    <span>{job?.division?.address?.display_text}</span>
                  </div>
                )}
                {timeSlot.cabinet && (
                  <div className="screening-info">
                    <strong>Кабінет:</strong>
                    <span>{timeSlot.cabinet}</span>
                  </div>
                )}
                {job.division.contacts && job.division.contacts.length > 0 && (
                  <>
                    {job.division.contacts.map((contact, index) => (
                      <div key={index} className="screening-info">
                        {contact.type === 'phone' && (
                          <>
                            <strong>Телефон:</strong>
                            <span>{contact.value}</span>
                          </>
                        )}
                        {contact.type === 'email' && (
                          <>
                            <strong>Email:</strong>
                            <span><a href={`mailto:${contact.value}`}>{contact.value}</a></span>
                          </>
                        )}
                      </div>
                    ))}
                  </>
                )}
                {job.division.reg_phone && (
                  <div className="screening-info">
                    <strong>Телефон реєстратури:</strong>
                    <span>{job.division.reg_phone}</span>
                  </div>
                )}
              </>
            )}
            <p className="screening-link">
              <strong>Детальніше про програму:</strong><br />
              <a href="https://screening.moz.gov.ua" target="_blank" rel="noopener noreferrer">
                screening.moz.gov.ua
              </a>
            </p>
          </div>
          <style>{`
            .screening-confirmation {
              padding: 15px 10px;
            }
            .screening-header {
              display: flex;
              align-items: center;
              gap: 15px;
              margin-bottom: 20px;
              padding-bottom: 20px;
              border-bottom: 1px solid #e0e0e0;
            }
            .screening-logo-wrapper {
              flex-shrink: 0;
            }
            .screening-logo {
              width: 52px;
              height: 48px;
            }
            .screening-content {
              flex: 1;
            }
            .screening-title {
              font-size: 15px !important;
              font-weight: 600 !important;
              color: #1767c8;
              margin-bottom: 10px;
              line-height: 1.4;
              margin-top: 0;
            }
            .screening-text {
              font-size: 14px !important;
              color: #333;
              margin-bottom: 0;
              line-height: 1.5;
            }
            p.screening-info {
              font-size: 14px !important;
              color: #555;
              margin-bottom: 10px;
              line-height: 1.5;
              text-align: left;
              padding: 0;
            }
            .screening-info {
              display: flex;
              align-items: baseline;
              font-size: 14px !important;
              color: #555;
              margin-bottom: 8px;
              line-height: 1.5;
              gap: 10px;
            }
            .screening-info strong {
                color: #696666;
                flex-shrink: 0;
                min-width: 180px;
                font-weight: 400;
            }
            .screening-info span {
              flex: 1;
              color: #333;
              font-weight: 500;
            }
            .screening-info a {
              color: #1767c8;
              text-decoration: none;
            }
            .screening-info a:hover {
              text-decoration: underline;
            }
            .screening-link {
              font-size: 14px;
              margin-top: 15px;
              padding-top: 15px;
              border-top: 1px solid #e0e0e0;
              text-align: center;
            }
            .screening-link strong {
              display: block;
              margin-bottom: 5px;
              color: #333;
            }
            .screening-link a {
              color: #1767c8;
              text-decoration: none;
              font-weight: 500;
            }
            .screening-link a:hover {
              text-decoration: underline;
            }
            .screening-info.institution span {
              color: #094fa3 !important;
            }
            @media (max-width: 576px) {
              .screening-header {
                flex-direction: column;
                align-items: center;
                text-align: center;
              }
              .screening-logo-wrapper {
                margin-bottom: 10px;
              }
              .screening-info {
                flex-direction: column;
                align-items: flex-start;
                gap: 2px;
              }
              .screening-info strong {
                min-width: auto;
              }
            }
          `}</style>
        </>
      ) : patient ? (
        <>
          <p className="appointment-auth-text">
            <span className="name">Пацієнт&nbsp;{patient?.full_name}&nbsp;</span>
            {patient?.sex === 'male' ? 'записаний' : 'записана'} на прийом успішно!
          </p>
          <p className="appointment-confirmation-text">
            Просимо завітати до закладу не пізніше, ніж о <span className="time">{time}</span> та повідомити реєстратуру.
          </p>
        </>
      ) : (
        <>
          <div className="appointment-success-banner">
            <span className="appointment-success-banner__icon">✓</span>
            <span className="appointment-success-banner__text">Запис на прийом успішно завершено</span>
          </div>
          {!window.ReactNativeWebView && (
            <div className="app-promo-block">
              <div className="app-market-search-row" role="presentation">
                <img src="/favicon.ico" alt="Лікарі 24/7" className="app-market-search-row__icon" />
                <div className="app-market-search-row__meta">
                  <div className="app-market-search-row__name">Лікарі 24/7</div>
                  <div className="app-market-search-row__company">ТОВ "СІЕТ Холдінг"</div>
                </div>
              </div>
              <p className="app-promo-title">Рекомендуємо встановити наш застосунок</p>
              <p className="app-promo-text">
                Можливість перегляду Ваших медичних даних, статусу і результатів прийомів, отримуйте нагадування та сповіщення прямо на телефон.<br/>Рекомендуємо використовувати застосунок Likari 24/7.
              </p>
              <AppsList />
            </div>
          )}
        </>
      )}
      
      {showSearchBtn && job?.institution && user.city && (
        <p className='text-center mb-3'>
          <button 
              className="btn btn-outline-primary"
              onClick={() => {
                window.location = `/city/${user.city.id}/list/?institution_id=${job.institution.id}&visit_date=${moment(timeSlot.datetime).format('YYYY-MM-DD')}&onlyAvailable=true`;
              }}
            >
              Записатись до інших спеціалістів на {moment(timeSlot.datetime).format('DD.MM.YYYY')}
            </button>
        </p>
      )}
      
      <Button type="submit" variant="primary" className="submit-button" onClick={onClose}>
        Закрити
      </Button>
    </form>
  );
};

export default Confirmation;
